export function newsDateConverter(dateString) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString("de-DE", options);
}

const GENERIC_NEWS_TAGS = ["Rugby", "Bundesliga"];

export function getNewsCategory(article) {
  return article.tags?.find(tag => !GENERIC_NEWS_TAGS.includes(tag));
}
